import {
    AuthenticationResponseJSON,
    PublicKeyCredentialCreationOptionsJSON,
    PublicKeyCredentialRequestOptionsJSON,
    RegistrationResponseJSON,
} from '@simplewebauthn/browser';

export enum StrongAuthMethod {
    Passkey = 'passkey',
    Totp = 'totp',
}

export enum StrongAuthLoginState {
    Complete = 'complete',
    VerificationRequired = 'verification-required',
    EnrollmentRequired = 'enrollment-required',
}

export interface StrongAuthLoginResponse {
    state: StrongAuthLoginState;
    methods: StrongAuthMethod[];
    continuation?: string;
    token?: string;
}

export interface TotpEnrollmentResponse {
    continuation: string;
    secret: string;
    otpauthUri: string;
}

export interface PasskeyRegistrationOptionsResponse {
    continuation: string;
    options: PublicKeyCredentialCreationOptionsJSON;
}

export interface PasskeyAuthenticationOptionsResponse {
    continuation: string;
    options: PublicKeyCredentialRequestOptionsJSON;
}

export interface UserPasskey {
    credentialId: string;
    name: string;
    createdAt: string;
    lastUsedAt?: string;
    deviceType: string;
    backedUp: boolean;
}

export interface UserSecurityCredentials {
    hasTotp: boolean;
    totpEnrolledAt?: string;
    totpLastUsedAt?: string;
    passkeys: UserPasskey[];
    recoveryEnrollmentAllowed: boolean;
}

export function requiresFreshVerificationForEnrollment(
    credentials: UserSecurityCredentials | null
): boolean {
    if (!credentials) return false;
    const hasMethod = credentials.hasTotp || credentials.passkeys.length > 0;
    return hasMethod && !credentials.recoveryEnrollmentAllowed;
}

export interface OrganizationMemberSecurityStatus {
    userId: string;
    email: string;
    hasStrongAuthMethod: boolean;
    activeExemption: null | {
        id: string;
        reason: string;
        expiresAt: string;
    };
}

export type { AuthenticationResponseJSON, RegistrationResponseJSON };
